var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Play-List-9--Streamline-Core",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Play List 9 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "play-list-9--player-television-movies-slider-media-tv-players-video-stack-entertainment"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1681",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.6875 5.65625c0 -0.55228 0.44772 -1 1 -1h7.75c0.5523 0 1 0.44772 1 1v5.99995c0 0.5523 -0.4477 1 -1 1h-7.75c-0.55228 0 -1 -0.4477 -1 -1V5.65625Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1682",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.5 2.875v-0.28125c0 -0.55228 -0.4477 -1 -1 -1H1.75c-0.55228 0 -1 0.44772 -1 1v6c0 0.55228 0.44772 1 1 1h0.1875",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m7.5 6.78125 3 1.875 -3 1.87495V6.78125Z",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayVideoIcon);
export default __webpack_public_path__ + "static/media/play-video-icon.34f4487dd8b331aadb0b3b6b47ad5464.svg";
export { ForwardRef as ReactComponent };